module.exports = __webpack_public_path__ + "img/fondoLogin.0cb036b7.png";